var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStipend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3485 2.59992L7.49408 0L0.6755 5.44717L0.2975 5.44308V5.44892H0V12.4489H12.25V5.44892H11.6888L10.5723 2.18283L9.3485 2.59992ZM10.4562 5.44892H4.60658L8.9635 3.96375L9.85133 3.67967L10.4562 5.44892ZM8.19583 2.99308L3.69833 4.52608L7.26017 1.68058L8.19583 2.99308ZM1.16667 10.2142V7.6825C1.41277 7.59529 1.63631 7.45425 1.82099 7.26968C2.00567 7.0851 2.14682 6.86164 2.23417 6.61558H10.0158C10.1031 6.86173 10.2443 7.08529 10.429 7.26996C10.6136 7.45464 10.8372 7.59578 11.0833 7.68308V10.2147C10.8372 10.3021 10.6136 10.4432 10.429 10.6279C10.2443 10.8125 10.1031 11.0361 10.0158 11.2822H2.23533C2.14794 11.0359 2.00665 10.8122 1.82176 10.6274C1.63688 10.4426 1.41307 10.3014 1.16667 10.2142Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStipend);
export default __webpack_public_path__ + "static/media/Stipend.6d7201f81b4b32781c03d452fb8243de.svg";
export { ForwardRef as ReactComponent };